import Link from 'components/links/Link';
import React, { useState } from 'react';
import { formatDuration } from 'utils/formatting';

import Button from '../buttons/Button';

function PoiMountainPaths({ paths }) {
    const [showMore, setShowMore] = useState(false);
    const initiallyShown = 5;

    return (
        <div className="max-w-4xl">
            <div className="space-y-2">
                {paths.map((p, i) => {
                    if (!showMore && i > initiallyShown) return null;
                    return (
                        <div
                            key={p.id}
                            className="rounded-3xl bg-gray-100 text-primary py-3 px-6 grid grid-cols-8 md:gap-6 gap-4"
                        >
                            <div className="hover:underline font-medium col-span-8 md:col-span-4">
                                <Link target="_blank" to={p.url}>
                                    {p.name}
                                </Link>
                            </div>
                            <div className="col-span-3 md:col-span-2">{formatDuration(p.duration)}</div>
                            <div className="col-span-5 md:col-span-2">{p.difficulty}</div>
                        </div>
                    );
                })}
            </div>

            <div className="flex justify-between mt-4">
                <div className="text-sm text-secondary">Vir: Hribi.net</div>
                {paths.length > 5 && !showMore && (
                    <div>
                        <Button variant="outlined" color="secondary" onClick={() => setShowMore(true)}>
                            Prikaži vseh {paths.length} poti
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
}

PoiMountainPaths.propTypes = {};

export default PoiMountainPaths;
